
import { CHEFS_JOURNEY_QUESTS } from './chefs-journey';
import { STANDARD_SKILL_BUILDER_QUESTS } from './standard';
import { YOUNG_AUTHOR_QUESTS } from './young-author';
import { MEMORY_MASTER_QUESTS } from './memory-master';
import { JUNIOR_ENGINEER_QUESTS } from './junior-engineer';
import { FIRST_RESPONDER_QUESTS } from './first-responder';
import { KNOWLEDGE_SEEKER_QUESTS } from './knowledge-seeker';
import { CLIMBING_CATALYST_QUESTS } from './climbing-catalyst';
import { YOUNG_ATHLETE_QUESTS } from './young-athlete';

export const SKILL_BUILDER_QUESTS = [
    ...CHEFS_JOURNEY_QUESTS,
    ...STANDARD_SKILL_BUILDER_QUESTS,
    ...YOUNG_AUTHOR_QUESTS,
    ...MEMORY_MASTER_QUESTS,
    ...JUNIOR_ENGINEER_QUESTS,
    ...FIRST_RESPONDER_QUESTS,
    ...KNOWLEDGE_SEEKER_QUESTS,
    ...CLIMBING_CATALYST_QUESTS,
    ...YOUNG_ATHLETE_QUESTS,
];